const settings = {
  dev: {
    url: 'https://030kpjjf6l.execute-api.eu-central-1.amazonaws.com/test/ip',
    key: 'dZH9jY3lRu48XNIUHSRMj4ZJ8LP2iAz76Pxr2NwY',
  },
  test: {
    url: 'https://030kpjjf6l.execute-api.eu-central-1.amazonaws.com/test/ip',
    key: 'dZH9jY3lRu48XNIUHSRMj4ZJ8LP2iAz76Pxr2NwY',
  },
  prod: {
    url: 'https://swy2wottl6.execute-api.eu-central-1.amazonaws.com/prod/ip',
    key: 'bJXdtm18Pq9c5VKynsUDv9VnitlDx3GJ8hqC1nPo',
  },
}

export const getSourceIP = async () => {
  const url = settings[process.env.STAGE]
    ? settings[process.env.STAGE].url
    : settings.dev.url
  const resp = await fetch(url, {
    mode: 'cors',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': settings[process.env.STAGE].key,
    },
  })
  return resp.json()
}
